<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app style="background-color: #ebf0ff ;">
      <v-snackbar
        v-model="showSnackBar"
        color="#7CB9E8"
        right
        :timeout="timeout"
      >
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showSnackBar = false">
              <v-icon style="color: white">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>

      <AppHeader
        v-if="
          $route.name != 'Login' &&
          $route.name != 'Register' &&
          $route.name != 'Forgot' &&
          $route.name != 'CheckEmail' &&
          $route.name != 'Verify'
        "
         @stepper="winStepper"
      />
      <router-view v-bind:storage="sideNav" />
      <AppFooter
        v-if="
          $route.name != 'Login' &&
          $route.name != 'Register' &&
          $route.name != 'Forgot' &&
          $route.name != 'CheckEmail' &&
          $route.name != 'Verify'
        "
      />
    </v-app>
  </div>
</template>

<script>
import AppHeader from "./components/Common/appHeader";
import AppFooter from "./components/Common/appFooter";
import axios from "axios";

import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";
export default {
  name: "App",

  components: {
    AppHeader,
    AppFooter,
  },

  data: () => ({
    //
    appLoading: false,
    ServerError: false,
    showSnackBar: false,
    msg: null,
    timeout: 5000,
    sideNav: true,
  }),
  beforeMount() {
    if (typeof localStorage.getItem("token") == "string") {
      this.getProfile();
    }
  },
  methods: {
    winStepper(windowData) {
      this.sideNav = windowData.sideNav;
    },
    getProfile() {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("loginUser", response.data.data.status);
            this.$store.commit("userData", response.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
